var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},_vm._l((_vm.cellValue),function(item,index){return _c('el-button',{key:index,class:{ default: item.class },attrs:{"type":"text"},on:{"click":function($event){return _vm.click(item)}}},[_vm._v("\n\t\t"+_vm._s(item.label)+"\n\t")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }